import React from 'react'
import { useParams } from 'react-router-dom';
import { useLazyGeneratePDFForIndividualMemberQuery } from '../../app/services/ViewIndividulaMember/ViewIndividualMemberServiceApi';
import { decryptAESID } from '../../utils/Encryption';
import Buttons from '../../components/ui/button/Buttons';
import { useEffect } from 'react';
import { saveAs } from 'file-saver';

const GeneratePDFForMember = () => {
    const { taskListId } = useParams();
    const [generatePDF, { isSuccess: isSuccessGetPDF, isLoading: isLoadingGetPDF, data: getPDFData }] = useLazyGeneratePDFForIndividualMemberQuery();
    const handleDownloadPDF = async () => {
        let memberIdDecrypted = decryptAESID(taskListId)
        // let requestType = props.type;
        let response;
        let requet = { id: memberIdDecrypted.toString() };
        response = await generatePDF(requet);

        if (response && response.data) {
            const { fileData, fileName } = response.data;
            const blob = new Blob([fileData], { type: 'application/pdf' });
            let tempfileName = 'IndividualMemberPDF.pdf';
            saveAs(blob, tempfileName, fileName);
        }
    }
    useEffect(() => {
        if (!isLoadingGetPDF && isSuccessGetPDF && getPDFData) {

        }
    }, [isLoadingGetPDF, isSuccessGetPDF, getPDFData])
    return (
        <React.Fragment>
            <Buttons buttonText='Generate PDF' onClick={handleDownloadPDF}></Buttons>
        </React.Fragment>
    )
}

export default GeneratePDFForMember